export default {"src":"/_next/static/media/sailing-together-sm.colour.154986fe.svg","height":374,"width":408,"blurWidth":0,"blurHeight":0};